/** UI copy for airtisto24 — Svenska + English */
export const SUPPORTED = [
  { code: 'sv', label: 'Svenska', flag: 'SE' },
  { code: 'en', label: 'English', flag: 'GB' },
];

const CONTACT = {
  email: 'mybestartist.se@silverlines.info',
  hotline: '+46 720500350',
  smsKeyword: 'MBA',
  stopKeyword: 'STOP MBA',
  shortcode: '72197',
  countryCode: '+46',
};

export const contact = CONTACT;

export const strings = {
  sv: {
    brand: 'airtisto24',
    brandDomain: 'airtisto24.com',
    nav: {
      home: 'Hem',
      gallery: 'Galleri',
      features: 'Funktioner',
      legal: 'Juridisk information',
    },
    headerCta: 'Skapa nu',
    hero: {
      badge: 'AI-driven bildgenerator',
      title: 'airtisto24',
      tagline:
        'Skapa enkelt fantastiska och unika bilder med vår AI-drivna bildgenerator!',
      formLabel: 'Ange ditt telefonnummer',
      phonePlaceholder: '70 123 45 67',
      submit: 'FORTSÄTTA',
      priceNote:
        'Aktivera prenumerationen 50 kr per vecka. Avsluta prenumerationen: STOP MBA till 72197. airtisto24, AI-bildgenerator. För mer information skicka e-post till: mybestartist.se@silverlines.info eller ring hotline: +46 720500350 .',
      legalLong:
        'airtisto24, AI-bildgenerator. Detta är en prenumerationstjänst som kostar 50 KR per vecka. Nätverksavgifter kan tillkomma. Du kan avbryta tjänsten när som helst genom att skicka ett textmeddelande med ordet STOP MBA till 72197. Du kan även ringa oss på +46 720500350 eller skicka ett e-postmeddelande till mybestartist.se@silverlines.info.',
    },
    stats: [
      { value: '250K+', label: 'Genererade bilder' },
      { value: '50+', label: 'Konststilar' },
      { value: '99%', label: 'Kundnöjdhet' },
      { value: '24/7', label: 'Tillgänglighet' },
    ],
    gallery: {
      title: 'Exempel på genererade bilder',
      subtitle:
        'Upptäck kraften i vår AI genom dessa skapelser gjorda av våra användare',
      styleLabel: 'Stil',
      items: [
        {
          title: 'Söt robot',
          style: 'AI',
          prompt: 'en söt robot på ett dukat bord',
          author: 'Marie D.',
          role: 'Designer',
        },
        {
          title: 'Manga-cykel',
          style: 'Manga',
          prompt: 'en man som cyklar i manga-stil med en solnedgång',
          author: 'Thomas L.',
          role: 'Illustratör',
        },
        {
          title: 'AI-drake',
          style: 'Fantastisk',
          prompt: 'en snäll drake som flyger över havet vid solnedgången',
          author: 'Sophie M.',
          role: 'Författare',
        },
        {
          title: 'AI-kattunge',
          style: 'Söt',
          prompt: 'en söt kattunge ovanifrån som tittar på oss',
          author: 'Julie B.',
          role: 'Fotograf',
        },
        {
          title: 'AI-luftballong',
          style: 'Surrealistisk',
          prompt: 'en luftballong som flyger på månen',
          author: 'Pierre L.',
          role: 'Konstnär',
        },
        {
          title: 'Land Rover i snö',
          style: 'Realistisk',
          prompt: 'land rover discovery 4 i snö',
          author: 'Marc T.',
          role: 'Bilentusiast',
        },
      ],
    },
    features: {
      title: 'Nyckelfunktioner',
      subtitle: 'Allt du behöver för att ge liv åt din kreativitet',
      items: [
        {
          title: 'Högkvalitativ bildgenerering',
          description:
            'Skarpa, detaljerade och professionella visuella material, anpassade för alla dina behov (print, digitalt, sociala medier).',
        },
        {
          title: 'Avancerade AI-algoritmer',
          description:
            'Banbrytande modeller som förstår dina prompts och anpassar sig till din stil för unika resultat.',
        },
        {
          title: 'Flera enheter',
          description:
            'Användbar på mobil, surfplatta eller dator, utan installation. Din kreativitet följer dig överallt.',
        },
        {
          title: 'Olika format & stilar',
          description:
            'Från akvarell till serietidningsstil – utforska ett brett kreativt spektrum och byt stil med ett klick.',
        },
        {
          title: 'Flexibla priser',
          description:
            'Abonnemang som passar alla behov, utan bindningstid. Betala bara för det du behöver.',
        },
        {
          title: 'Intuitivt gränssnitt',
          description:
            'Inga tekniska färdigheter krävs: ett tydligt, enkelt och guidat gränssnitt för alla skapare.',
        },
      ],
    },
    about: {
      kicker: 'Om tjänsten',
      title: 'airtisto24',
      intro:
        'Efter att ha köpt airtisto24-pass får användarna tillgång till AI-bildgeneratorn och kan börja skapa fantastiska visuella verk. Tjänsten kostar 50 kr per vecka.',
      activation:
        'För att aktivera tjänsten: skicka ett SMS med texten « MBA » till nummer 72197.',
      paragraphs: [
        'Genom att aktivera tjänsten bekräftar du att du har tagit del av de allmänna villkoren och accepterar att gratis ta emot marknadsförings- och reklaminformation från tjänsteleverantören.',
        'Avgifterna inkluderar inte användning av mobilt internet.',
        'Tjänsteleverantör: MOBILE BOOST, 25 avenue de Verdun - 06500 Menton, FRANKRIKE.',
      ],
    },
    footer: {
      linksTitle: 'Användbara länkar',
      blurb:
        'airtisto24 — skapa enkelt fantastiska och unika bilder med vår AI-drivna bildgenerator.',
      copyright:
        '© 2025 airtisto24.com - Alla rättigheter förbehållna. Publicerad av Mobile Boost',
      address: '25 avenue de Verdun, 06500 Menton Frankrike',
      contactTitle: 'Kontakt',
    },
  },

  en: {
    brand: 'airtisto24',
    brandDomain: 'airtisto24.com',
    nav: {
      home: 'Home',
      gallery: 'Gallery',
      features: 'Features',
      legal: 'Legal information',
    },
    headerCta: 'Create now',
    hero: {
      badge: 'AI-powered image generator',
      title: 'airtisto24',
      tagline:
        'Easily create stunning and unique images with our AI-powered image generator!',
      formLabel: 'Enter your phone number',
      phonePlaceholder: '70 123 45 67',
      submit: 'CONTINUE',
      priceNote:
        'Activate the subscription 50 kr per week. Cancel the subscription: STOP MBA to 72197. airtisto24, AI image generator. For more information email: mybestartist.se@silverlines.info or call the hotline: +46 720500350 .',
      legalLong:
        'airtisto24, AI image generator. This is a subscription service that costs 50 KR per week. Network fees may apply. You can cancel the service at any time by sending a text message with the word STOP MBA to 72197. You can also call us at +46 720500350 or send an email to mybestartist.se@silverlines.info.',
    },
    stats: [
      { value: '250K+', label: 'Generated images' },
      { value: '50+', label: 'Art styles' },
      { value: '99%', label: 'Customer satisfaction' },
      { value: '24/7', label: 'Availability' },
    ],
    gallery: {
      title: 'Examples of generated images',
      subtitle:
        'Discover the power of our AI through these creations made by our users',
      styleLabel: 'Style',
      items: [
        {
          title: 'Cute robot',
          style: 'AI',
          prompt: 'a cute robot at a set table',
          author: 'Marie D.',
          role: 'Designer',
        },
        {
          title: 'Manga cyclist',
          style: 'Manga',
          prompt: 'a man cycling in manga style with a sunset',
          author: 'Thomas L.',
          role: 'Illustrator',
        },
        {
          title: 'AI dragon',
          style: 'Fantasy',
          prompt: 'a friendly dragon flying over the sea at sunset',
          author: 'Sophie M.',
          role: 'Writer',
        },
        {
          title: 'AI kitten',
          style: 'Cute',
          prompt: 'a cute kitten from above looking at us',
          author: 'Julie B.',
          role: 'Photographer',
        },
        {
          title: 'AI hot air balloon',
          style: 'Surreal',
          prompt: 'a hot air balloon flying on the moon',
          author: 'Pierre L.',
          role: 'Artist',
        },
        {
          title: 'Land Rover in snow',
          style: 'Realistic',
          prompt: 'land rover discovery 4 in snow',
          author: 'Marc T.',
          role: 'Car enthusiast',
        },
      ],
    },
    features: {
      title: 'Key features',
      subtitle: 'Everything you need to bring your creativity to life',
      items: [
        {
          title: 'High-quality image generation',
          description:
            'Sharp, detailed and professional visuals, adapted to all your needs (print, digital, social media).',
        },
        {
          title: 'Advanced AI algorithms',
          description:
            'Cutting-edge models that understand your prompts and adapt to your style for unique results.',
        },
        {
          title: 'Multiple devices',
          description:
            'Usable on mobile, tablet or computer, with no installation. Your creativity follows you everywhere.',
        },
        {
          title: 'Various formats & styles',
          description:
            'From watercolor to comic-book style – explore a broad creative spectrum and switch styles with one click.',
        },
        {
          title: 'Flexible pricing',
          description:
            'Subscriptions that fit every need, with no commitment. Pay only for what you need.',
        },
        {
          title: 'Intuitive interface',
          description:
            'No technical skills required: a clear, simple and guided interface for all creators.',
        },
      ],
    },
    about: {
      kicker: 'About the service',
      title: 'airtisto24',
      intro:
        'After purchasing the airtisto24 pass, users get access to the AI image generator and can start creating amazing visual works. The service costs 50 kr per week.',
      activation:
        'To activate the service: send an SMS with the text « MBA » to number 72197.',
      paragraphs: [
        'By activating the service you confirm that you have read the general terms and conditions and agree to receive, free of charge, marketing and promotional information from the service provider.',
        'The fees do not include the use of mobile internet.',
        'Service provider: MOBILE BOOST, 25 avenue de Verdun - 06500 Menton, FRANCE.',
      ],
    },
    footer: {
      linksTitle: 'Useful links',
      blurb:
        'airtisto24 — easily create stunning and unique images with our AI-powered image generator.',
      copyright:
        '© 2025 airtisto24.com - All rights reserved. Published by Mobile Boost',
      address: '25 avenue de Verdun, 06500 Menton France',
      contactTitle: 'Contact',
    },
  },
};
